import { render, staticRenderFns } from "./PageFormDate.vue?vue&type=template&id=724ddc60&scoped=true&"
import script from "./PageFormDate.vue?vue&type=script&lang=ts&"
export * from "./PageFormDate.vue?vue&type=script&lang=ts&"
import style0 from "./PageFormDate.vue?vue&type=style&index=0&id=724ddc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ddc60",
  null
  
)

export default component.exports